import React from 'react';
import PropTypes from "prop-types";
import AvailabilityAssistanceButton from "./AvailabilityAssistanceButton";
import TimeslotsInput from "./TimeslotsInput";

const AvailabilityDay = (props) => {
    return (
        <div className="cell auto">
            <div className="amenity-availability-day grid-x">
                <div className="cell small-8">
                    {props.day}
                </div>
                <div className="cell small-4 text-right">
                    <AvailabilityAssistanceButton
                        allAvailability={props.allAvailability}
                        day={props.day}
                        onAvailibilityChange={props.onWholeWeekAvailabilityChange}
                    />
                    &nbsp;
                </div>
            </div>

            <TimeslotsInput
                dateIndex={props.day}
                slotValues={props.daySlots ?? []}
                onChange={props.onChange}
                placeholder={`${props.day === 'monday' ? "e.g. HH:MM-HH:MM" : ""}`}
            />
        </div>
    );
};

AvailabilityDay.propTypes = {
    day: PropTypes.string,
    daySlots: PropTypes.array,
    allAvailability: PropTypes.object,
    onChange: PropTypes.func,
    onWholeWeekAvailabilityChange: PropTypes.func,
};

export default AvailabilityDay;
